import { UserEmailPrefsDto } from "../../types/dto";
import { get, isMockMode, simulateDelay } from "../api";

export interface GetEmailPrefsRequest {
	code: string;
	email: string;
}

export const getEmailPrefs = (
	data: GetEmailPrefsRequest
): Promise<UserEmailPrefsDto> => {
	if (isMockMode()) {
		const testData: UserEmailPrefsDto = {
			notifyAboutSubActivation: true,
			notifyManagersAboutLicenceIssued: true,
			notifyUsersAboutNewLicence: true,
			notifyUsersAboutSetLicenceState: true,
		};

		return simulateDelay(50, () => testData);
	}

	return get(
		`EmailPrefs/Get?Code=${data.code}&Email=${encodeURIComponent(
			data.email
		)}`
	);
};
